import { OAuthClient } from './OAuthClient';

export { AuthError } from './error';

export default new OAuthClient();
